import { BackdropLoader } from '@livable/saas-react-components';
import { Alert, Button, Paper, Typography } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';
import useStyles from './styles';
const ModalContent = _ref => {
  let disabled = _ref.disabled,
    handleModalClose = _ref.handleModalClose,
    isLoading = _ref.isLoading,
    submitForm = _ref.submitForm;
  const classes = useStyles();
  const _useTranslation = useTranslation(),
    t = _useTranslation.t;
  return /*#__PURE__*/React.createElement(Paper, null, /*#__PURE__*/React.createElement(BackdropLoader, {
    isOpen: isLoading
  }), /*#__PURE__*/React.createElement(Alert, {
    icon: false,
    severity: "warning",
    size: "small"
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "h5"
  }, t('add_new_property_flow.confirmation_fee_text'))), /*#__PURE__*/React.createElement("div", {
    className: classes.footer
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleModalClose,
    type: "button",
    variant: "text",
    'custom-attribute': '105-custom-fee-confirmation'
  }, t('buttons.cancel')), /*#__PURE__*/React.createElement(Button, {
    disabled: disabled,
    onClick: submitForm,
    type: "submit",
    variant: "contained",
    'custom-attribute': '106-custom-fee-confirmation'
  }, t('add_new_property_flow.confirmation_fee_submit')))));
};
export default ModalContent;